import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    parentProductId: string;
    includeProductId: string;
};

type HandlerType = Handler<Parameter>;

const DispatchRemoveClipboardIncludeItem: HandlerType = props => {
    props.dispatch({
        type: "Widgets/Clipboard/RemoveIncludeItem",
        parameter: {
            parentProductId: props.parameter.parentProductId,
            includeProductId: props.parameter.includeProductId,
        },
    });
};

const chain = [DispatchRemoveClipboardIncludeItem];

const removeClipboardIncludeItem = createHandlerChainRunner(chain, "RemoveClipboardIncludeItem");
export default removeClipboardIncludeItem;
